/**
 * description:
 * dateTime: 2024/8/21-下午5:11
 * author: ZhangJun 1580043700@qq.com
 */

import {SLowcodeList} from "shj-components";
import {configGrowth, configIntegral} from "../config.tsx";
import {tableApiFunc} from "@/utils/data.ts";
import {queryMemberEventDetailListByPage} from "@/services/member.ts";
import {useNavigate} from "react-router-dom";
import {useRef} from "react";

/**
 * 积分流水
 * @constructor
 */
export function Integral(props) {

    const tableRef: any = useRef()
    const history = useNavigate()
    const onExport = () => {
        // TODO 暂无接口
        return;
        // const pagination = tableRef.current?.getPagination?.();
        // const searchParams = tableRef.current?.getSearch?.()?.getFieldsValue?.();
        // const dataQuery = {
        //     current: pagination?.current ?? 1,
        //     pageSize: pagination?.pageSize ?? 10,
        //     ...searchParams
        // }
        //
        // const data = {
        //     "taskName": "会员信息导出",
        //     "reqParam": JSON.stringify(dataQuery),
        //     "taskCode": "DistributionRecordExcelImpl",
        //     "taskSource": "MembeInfoExcelImpl",
        //     "taskRemark": "会员信息导出"
        // }
        // message.loading({content: '导出中'})
        // downloadExcel(data)
        //     .then(() => {
        //         history('/main/download');
        //     })
        //     .catch(() => {
        //         message.error('导出失败')
        //     })
    }
    const extensions = {
        request: {
            fetchList: tableApiFunc(queryMemberEventDetailListByPage, {
                paginationInBody: true,
                data: {type: '1', memberId: props.memberId},
                fieldNames: {current: 'current'},
            }),
        },
        events: {onExport},
    }
    return (
        <SLowcodeList
            searchMode={'group'}
            config={configIntegral}
            {...extensions}
            ref={tableRef}
        />
    )
}

/**
 * 成长值流水
 * @constructor
 */

export function Growth(props) {

    const tableRef: any = useRef()
    const history = useNavigate()

    const onExport = () => {
        // TODO 暂无接口
        return;
        // const pagination = tableRef.current?.getPagination?.();
        // const searchParams = tableRef.current?.getSearch?.()?.getFieldsValue?.();
        // const dataQuery = {
        //     current: pagination?.current ?? 1,
        //     pageSize: pagination?.pageSize ?? 10,
        //     ...searchParams
        // }
        //
        // const data = {
        //     "taskName": "会员信息导出",
        //     "reqParam": JSON.stringify(dataQuery),
        //     "taskCode": "DistributionRecordExcelImpl",
        //     "taskSource": "MembeInfoExcelImpl",
        //     "taskRemark": "会员信息导出"
        // }
        // message.loading({content: '导出中'})
        // downloadExcel(data)
        //     .then(() => {
        //         history('/main/download');
        //     })
        //     .catch(() => {
        //         message.error('导出失败')
        //     })
    }

    const extensions = {
        request: {
            fetchList: tableApiFunc(queryMemberEventDetailListByPage, {
                paginationInBody: true,
                data: {type: '2', memberId: props.memberId},
                fieldNames: {current: 'current'},
            }),
        },
        events: {onExport},
    }
    return (
        <SLowcodeList
            searchMode={'group'}
            config={configGrowth}
            {...extensions}
            ref={tableRef}
        />
    )
}
